import RouterViewBody from '~/views/RouterViewBody.vue'
import store from "@/store";
export default [
  {
    path: 'personnel-department',
    component: () => import('~/views/template/ViewsTemplateMain.vue'),
    props: { type: 'personnel_department' },
    name: 'Employees',
    redirect: { name: 'employeesAll' },
    meta: {
      access: { abilities: ['view_hr'] },
      breadCrumbLocalStorage: 'translations',
      breadCrumb: (translation) => translation.pages.pages.buttons['otdel-kadrov'],
    },
    children: [
      {
        path: 'employees',
        component: RouterViewBody,
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.personnel_department.pages['sotrudniki'],
        },
        children: [
          {
            path: '',
            name: 'employeesAll',
            component: () => import('~/views/employees/employees.vue'),
            meta: {
              search: true,
              paginations: {
                page: 1,
                limit: 10,
                style_list: 'grid',
              },
              responsive: true,
            },
          },
          {
            path: ':userId',
            component: RouterViewBody,
            props: true,
            meta: {
              breadCrumbGetter: 'commonUser/commonUserData',
              breadCrumb: (user) =>
                user.last_name && user.first_name ? user.first_name + ' ' + user.last_name : '',
            },
            children: [
              {
                path: '',
                name: 'PersonalAreaEmployee',
                component: () => import('~/views/personalArea/personalArea.vue'),
                meta: {
                  responsive: true,
                },
              },
              {
                path: 'edit',
                name: 'PersonalAreaEmployeeEdit',
                component: () => import('~/views/personalArea/personalAreaAdministration.vue'),
                meta: {
                  responsive: true,
                  access: { abilities: ['edit_hr'] },
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                      translation.pages.common.breadcrumbs['redaktirovanie'],
                },
              },
              {
                path: 'edit1',
                name: 'PersonalAreaEmployeeEdit',
                component: () => import('~/views/personalArea/personalArea.vue'),
                meta: {
                  responsive: true,
                  access: { abilities: ['edit_hr'] },
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages.common.breadcrumbs['redaktirovanie'],
                },
              },
              {
                path: 'pdf',
                name: 'PersonalAreaEmployeePdf',
                component: () => import('~/views/personalArea/personalAreaPdf.vue'),
                props: true,
                meta: {
                  breadCrumb: 'PDF',
                },
              },
              {
                path: 'statistic/:employeeId',
                name: 'employeeStatistic',
                component: () => import('~/views/sales/timeControl/timeControlShowEmployee.vue'),
                meta: {
                  responsive: true,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages.projects.pages.statistics,
                },
              },
            ],
          },
        ],
      },

      {
        path: 'group',
        component: RouterViewBody,
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) =>
            translation.pages.personnel_department.pages['podrazdeleniya'],
        },
        children: [
          {
            path: '',
            name: 'employeesGroup',
            component: () => import('~/views/employees/employeesGroup.vue'),
            meta: {
              paginations: {
                page: 1,
                limit: 10,
                style_list: 'table',
              },
              responsive: true,
            },
          },
          {
            path: ':id',
            name: 'employeesGroupSelect',
            component: () => import('~/views/employees/employeesGroupSelect.vue'),
            meta: {
              breadCrumbGetter: 'employeeGroup/employeeGroupShow',
              breadCrumb: (group) => group.name,
              responsive: true,
            },
          },
        ],
      },
    ],
  },
]
